const passos = [
  {
    emoji: '🧠',
    numero: '1',
    titulo: 'Perceber os sinais',
    descricao: 'Aprenda a identificar quando a crise está começando, antes que a situação saia do controle.'
  },
  {
    emoji: '🔍',
    numero: '2',
    titulo: 'Entender o gatilho',
    descricao: 'Descubra o que está por trás do comportamento: confusão, excesso de estímulos, dor ou mudanças na rotina.'
  },
  {
    emoji: '🛠',
    numero: '3',
    titulo: 'Saber o que fazer',
    descricao: 'Use estratégias simples e protocolos prontos para lidar com cada situação com mais segurança.'
  }
];

export default function MetodoSimples() {
  return (
    <section className="py-12 sm:py-20 bg-teal-50/40">
      <div className="max-w-5xl mx-auto px-4 sm:px-6">

        {/* Cabeçalho */}
        <div className="max-w-2xl mx-auto text-center mb-10 sm:mb-14 space-y-4">
          <p className="text-xs sm:text-sm font-semibold tracking-widest text-teal-600 uppercase">
            O método
          </p>
          <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 leading-tight">
            Um método simples para lidar com situações difíceis no Alzheimer
          </h2>
          <div className="w-12 h-1 bg-teal-500 rounded-full mx-auto"></div>
          <p className="text-base sm:text-lg text-gray-600 leading-relaxed">
            Você não precisa decorar técnicas complexas.{' '}
            <span className="font-medium text-gray-800">
              O protocolo ensina três passos práticos que podem ser aplicados no dia a dia.
            </span>
          </p>
        </div>

        {/* Cards */}
        <div className="grid sm:grid-cols-3 gap-5 sm:gap-6">
          {passos.map((passo) => (
            <div
              key={passo.numero}
              className="relative bg-white border border-teal-100 rounded-2xl p-6 sm:p-7 flex flex-col gap-4 hover:border-teal-300 transition-colors duration-200"
            >
              {/* Número de fundo */}
              <span className="absolute top-4 right-5 text-5xl font-black text-teal-50 select-none leading-none">
                {passo.numero}
              </span>

              {/* Emoji */}
              <div className="text-3xl">{passo.emoji}</div>

              {/* Título */}
              <h3 className="text-base sm:text-lg font-bold text-gray-900 leading-snug">
                <span className="text-teal-600 mr-1">Passo {passo.numero}.</span>
                {passo.titulo}
              </h3>

              {/* Descrição */}
              <p className="text-sm sm:text-base text-gray-600 leading-relaxed">
                {passo.descricao}
              </p>
            </div>
          ))}
        </div>

        {/* Linha conectora visual (desktop) */}
        <div className="hidden sm:flex items-center justify-center gap-0 mt-8">
          {[0, 1, 2].map((i) => (
            <div key={i} className="flex items-center">
              <div className="w-3 h-3 rounded-full bg-teal-400"></div>
              {i < 2 && <div className="w-32 lg:w-48 h-0.5 bg-teal-200"></div>}
            </div>
          ))}
        </div>

      </div>
    </section>
  );
}
